/**
 * Sandeep: Azure configuration.
 * [09/08/2023]
 */
import { AuthenticationResult, EventMessage, EventType, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import { initilizeUserInfo } from '../service/userService';

/**
 * Sandeep: Configuration object for instentiating msal library.
 * Loggin can be adjusted using on log level.
 */
export const msalConfig = {
    auth: msalConfigAuthOptions,
    cache: {
        cacheLocation: "sessionStorage",
        temporaryCacheLocation: "sessionStorage",
        storeAuthStateInCookie: true,
        secureCookies: true,
    },
    system: {
        allowRedirectInIframe: true, //Sandeep: Enable single logout
        loggerOptions: {
            logLevel: LogLevel.Error,
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
            piiLoggingEnabled: true,
            telemetry: {
                application: {
                    appName: "Trailboss",
                    appVersion: "1.0.0",
                },
            },
        }
    }
};

/**
 * Sandeep: Login request used for login and providing scopes while getting access token.
 */
export const loginRequest = {
    scopes: ['profile', 'openid', 'offline_access', msalConfigAuthOptions.clientId],
    extraQueryParameters: {
        ui_locales: 'en-us',
        "domain": "Advantage"//Sandeep: Additional parameter for custom policies.
    },
    state: "Advantage" //Sandeep: State passed is returned as is after login.
};

export const logoutRequest = {
    authority: msalConfigAuthOptions.authority,
    onRedirectNavigate:"dashboard"
};

/**
 * Sandeep: For calling Microsoft graph API.
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/me" //e.g. https://graph.microsoft.com/v1.0/me
};

/**
 * Sandeep: MSAL library initilization including event handling 
 * and setting active account for authetication and getting token.
 * @param msalInstance
 */
export const initilizeMsal = (msalInstance: PublicClientApplication) => {
    msalInstance.initialize().then(() => {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }

        msalInstance.addEventCallback((event: EventMessage) => {

            if (event.eventType === EventType.HANDLE_REDIRECT_START) {
                //Sandeep: Track the application from where we are trying to log in.
            }
            else if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
                const payload = event.payload as AuthenticationResult;
                const account = payload.account;
                msalInstance.setActiveAccount(account);
                // initilizeUserInfo(null);
            }
        });
    });
}